(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const screenshot = urlParams.get('qa');
  if (screenshot == '1') {
    document.addEventListener("DOMContentLoaded", (event) => {
      // Accordions
      const accordions = document.querySelectorAll(".product-info__accordion, .ds-accordion");
      for (const accordion of accordions) {
        accordion.setAttribute('aria-expanded', true);
        /*accordion.setAttriubte('style', 'overflow: visible; height: auto;');*/
        accordion.setAttribute('open', true);
      }

      // Services
      const services = document.querySelector(".ds-services");
      if (services) {
        services.style.display = "flex";
        services.style.flexWrap = "wrap";
        const children = services.querySelectorAll("a");

        children.forEach((item) => {
          item.style.flexBasis = "calc(33% - 0.375rem)";
        })
      }

      // Featured Collection
      const productList = document.querySelector(".ds-featured-collection__product-list");
      if (productList) {
        const products = productList.querySelectorAll("product-card");
        products.forEach((item) => {
          item.classList.remove('hidden');
        })
      }

      // Tabs
      const tabs = document.querySelector("x-tabs");
      if (tabs) {
        const tabPanels = tabs.querySelectorAll(".ds-tab-content");
        tabPanels.forEach((item) => {
          item.removeAttribute('hidden');
        })
      }
    });
  }
})();